import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

// Mirrors NoteTemplateForm's edit layout — page title and actions, then the
// card holding the Name and Content fields — so the page does not jump from a
// small centred spinner to the full-width form when the template loads.
export function NoteTemplateFormSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading note template"
      aria-hidden="true"
      className="tw:w-full tw:self-start tw:flex tw:justify-center"
    >
      <div className="tw:flex tw:w-full tw:max-w-6xl tw:flex-col tw:gap-4">
        <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
          <div className="tw:flex tw:flex-col tw:gap-2">
            <Skeleton className="tw:h-7 tw:w-56" />
            <Skeleton className="tw:h-4 tw:w-40" />
          </div>
          <div className="tw:flex tw:items-center tw:gap-3">
            <Skeleton className="tw:h-6 tw:w-11 tw:rounded-full" />
            <Skeleton className="tw:h-9 tw:w-20" />
            <Skeleton className="tw:h-9 tw:w-20" />
          </div>
        </div>

        <Card>
          <CardHeader>
            <Skeleton className="tw:h-6 tw:w-28" />
          </CardHeader>
          <CardContent className="tw:flex tw:flex-col tw:gap-5">
            <div className="tw:flex tw:flex-col tw:gap-2">
              <Skeleton className="tw:h-4 tw:w-16" />
              <Skeleton className="tw:h-9 tw:w-full" />
            </div>
            <div className="tw:flex tw:flex-col tw:gap-2">
              <Skeleton className="tw:h-4 tw:w-16" />
              <Skeleton className="tw:h-64 tw:w-full" />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
